import React, {PureComponent} from 'react';
import {Alert, Button, Form, Spinner, FormGroup, Label, Input, FormFeedback} from "reactstrap";
import {Formik} from "formik";
import * as yup from "yup";
import {requiredMessage} from "../../utils/form-validation";
import Dropdown from "../UI/Dropdown";
import {sanitizeForm} from "../../utils/sanitize-form";
import {IRoleAddFormRequest} from "../../models/Role";
import {getDictionaryOptions} from "../../utils/dictionaries";
import {IDictionary} from "../../models/Dictionary";


const schema = yup.object({
    name: yup.string().required(requiredMessage()),
    description: yup.string().required(requiredMessage()),
    permissions: yup.array().nullable().required(requiredMessage())
});

type RoleAddType = {
    addRoleForm: (form: IRoleAddFormRequest) => void
    changeLoading: boolean
    changeError: string
    cancelHandler?: () => void
    permissions:IDictionary[]
}

class RoleAdd extends PureComponent<RoleAddType> {
    render() {
        const {addRoleForm, changeLoading, changeError, cancelHandler, permissions} = this.props;
        const dictionaryPermissionOptions = getDictionaryOptions(permissions);
        return (
            <Formik
                validationSchema={schema}
                onSubmit={(values) => {
                    const name = sanitizeForm(values.name);
                    const description = sanitizeForm(values.description);
                    const permissions = sanitizeForm(values.permissions);

                    const form = {
                        name,
                        description,
                        permissions
                    };

                    addRoleForm(form)
                }}
                initialValues={{
                    name: '',
                    description: '',
                    permissions: null
                }}
            >
                {({
                      handleSubmit,
                      handleChange,
                      values,
                      touched,
                      errors,
                      setFieldValue
                  }) => (
                    <Form onSubmit={handleSubmit}>
                        <FormGroup>
                            <Label>Название <span className={'required'}>*</span></Label>
                            <Input
                                type="text"
                                name="name"
                                value={values.name}
                                onChange={handleChange}
                                invalid={touched.name && !!errors.name}
                            />
                            <FormFeedback>{errors.name}</FormFeedback>
                        </FormGroup>
                        <FormGroup>
                            <Label>Описание <span className={'required'}>*</span></Label>
                            <Input
                                type="text"
                                name="description"
                                value={values.description}
                                onChange={handleChange}
                                invalid={touched.description && !!errors.description}
                            />
                            <FormFeedback>{errors.description}</FormFeedback>
                        </FormGroup>
                        <FormGroup>
                            <Label>Права</Label>
                            <Dropdown
                                name={'permissions'}
                                value={values.permissions}
                                options={dictionaryPermissionOptions}
                                isMulti
                                onChange={(value) => setFieldValue('permissions', value)}
                                invalid={touched.permissions && !!errors.permissions}
                            />
                            <FormFeedback>{errors.permissions}</FormFeedback>
                        </FormGroup>
                        {changeError &&
                        (<Alert className={'mt-3'} color={'danger'}>
                            {changeError}
                        </Alert>)}
                        <div className={'text-right'}>
                            {cancelHandler &&
                            <Button color="light" onClick={cancelHandler} className={'mr-3'}>Отменить</Button>}
                            <Button type="submit" color={'primary'} disabled={changeLoading}>
                                {changeLoading &&
                                (<Spinner
                                    size="sm"
                                />)}
                                Создать
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        )
    }
}

export default RoleAdd;
